<template>
  <ValidationObserver v-slot="{ handleSubmit }" v-loading="isBusy">
    <form @submit.prevent="handleSubmit(updatePersonInCharge)">
      <div class="grid-filter">
        <ValidationProvider vid="personInCharge" name="Loại tác vụ" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Loại tác vụ <span style="color: red">*</span></span>
            <el-input v-model="form.type" disabled placeholder="Chọn loại tác vụ"/>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="personInCharge" name="Đối tượng xử lý" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Đối tượng xử lý <span style="color: red">*</span></span>
            <el-input v-model="form.personInCharge" disabled placeholder="Chọn đối tượng xử lý"/>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="personInCharge" name="Thời gian bắt đầu" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Thời gian bắt đầu <span style="color: red">*</span></span>
            <el-input v-model="form.startDate" disabled placeholder="Chọn nhân sự phụ trách"/>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="personInCharge" name="Thời gian kết thúc" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Thời gian kết thúc <span style="color: red">*</span></span>
            <el-input v-model="form.endDate" disabled placeholder="Chọn nhân sự phụ trách"/>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="personInCharge" name="Khóa học" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Khóa học <span style="color: red">*</span></span>
            <el-input v-model="form.course" disabled filterable clearable placeholder="Chọn nhân sự phụ trách"/>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="personInCharge" name="Người phụ trách" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Người phụ trách <span style="color: red">*</span></span>
            <el-select v-model="form.handlePerson" filterable clearable placeholder="Chọn nhân sự phụ trách">
              <el-option
                  v-for="item in adminList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
      </div>
      <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
        <el-button class="button-cancel" @click="closeDialog">Hủy bỏ</el-button>
        <el-button
            v-loading="loading"
            style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
            type="primary" native-type="submit"
            :disabled="loading">
          Xác nhận
        </el-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  GET_ALL_ADMIN_TEST,
  GET_DETAIL_TASK,
  UPDATE_PERSON_IN_CHARGE
} from "@/core/services/store/examSchedule/examSchedule";
import {MARK_GENERAL, MARK_SPEAKING} from "@/view/pages/marking-exam/model/taskPersonal";
import moment from "moment/moment";

export default {
  name: "DialogUpdateTaskDetail",
  props: {
    taskId: {
      type: Number,
      required: true,
      default: null
    },
    typeTask: {
      type: Number,
      required: true,
      default: 0,
    }
  },
  data() {
    return {
      loading: false,
      isBusy: false,
      adminList: [],
      form: {
        type: null,
        personInCharge: null,
        startDate: null,
        endDate: null,
        course: null,
        handlePerson: null
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
    },
    updatePersonInCharge() {
      this.loading = true
      const payload = {
        taskId: this.taskId,
        admin_profile_id: this.form.handlePerson
      }
      this.$store.dispatch(UPDATE_PERSON_IN_CHARGE, payload).then(res => {
        if (!res.error) {
          this.$message.success('Cập nhật tác vụ thành công !')
          this.closeDialog()
        }
      }).catch(e => {
        this.$message.error(e.data.message || 'Cập nhật tác vụ thất bại !')
      }).finally(() => this.loading = false)
    },
    getAdminList() {
      this.isBusy = true
      this.$store.dispatch(GET_ALL_ADMIN_TEST, {type_task: +this.typeTask}).then(res => {
        if (!res.error) {
          this.adminList = res.data.map((item) => {
            return {
              id: item.id,
              name: item.user_name,
            }
          })
          this.isBusy = false
        }
      })
    },
    getLabelType(type) {
      switch (type) {
        case MARK_SPEAKING:
          return 'Chấm thi speaking AI'
        case MARK_GENERAL:
          return 'Chấm thi General'
        default:
          return ''
      }
    },
    getDetailTask() {
      this.isBusy = true
      this.$store.dispatch(GET_DETAIL_TASK, this.taskId).then(res => {
        if (!res.error) {
          const data = res.data
          this.form.type = this.getLabelType(data.type)
          this.form.personInCharge = data.handler ?? ''
          this.form.startDate = moment(data.start_date).format('HH:mm:ss')
          this.form.endDate = moment(data.end_date).format('HH:mm:ss')
          this.form.course = data.course_name
          this.form.handlePerson = data.admin_profile.id
        }
      }).catch(e => {
        this.$message.error(e.data.message ?? 'Có lỗi xảy ra!')
      }).finally(() => this.isBusy = false)
    },
  },
  mounted() {
    this.getAdminList();
    this.getDetailTask()
  }
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 60px;
}
</style>